import * as React from "react";
import CardV1 from "./card_v1.component";
import CardV2 from "./card_v2.component";

declare const window: any;

export default function IntroContainer({ intro, progress, setIntroView, introView, isTheme, isLoaded, isPortrait, counter }: any) {
  const [isLegaltext, setIsLegalText] = React.useState(true);
  const [backgroundImage, setBackgroundImage] = React.useState("");
  
  React.useEffect(() => {
    if(Object.keys(intro).length < 1) //not loaded yet
      return;

    if(intro.type_product === "3D"){ //loaded but 3D, no preview required
      setBackgroundImage("");
      return;
    }
    //loaded and spin, preview requiered
    setBackgroundImage(
      `url(${window.hybrid ? (intro.lite ? `galleries/${window?.builder_id}/${window?.project_id}/galleries/lite/${window.innerWidth < window.innerHeight ? "portrait" : "landscape"}.webp` : `galleries/${window?.builder_id}/${window?.project_id}/spin/General/Spin general/${window.innerWidth < window.innerHeight ? "portrait" : "landscape"}/001.webp`).replace(
          / /g,
          "%20"
        ) : (intro.lite ? `https://d1bsymnertnea6.cloudfront.net/galleries/${window?.builder_id}/${window?.project_id}/galleries/lite/${window.innerWidth < window.innerHeight ? "portrait" : "landscape"}.webp` : `https://d1bsymnertnea6.cloudfront.net/galleries/${window?.builder_id}/${window?.project_id}/spin/General/Spin general/${window.innerWidth < window.innerHeight ? "portrait" : "landscape"}/001.webp`).replace(
          / /g,
          "%20"
        ) })`
    );
  }, [intro]);
  
  return (
    <div
      className={`intro-container ${introView ? "active" : ""}`}
      style={{
        backgroundImage: backgroundImage,
        //backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        //display: isLegaltext ? "block" : "flex",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundPosition: 'center 50%'
      }}
    >
      {isLegaltext ? <CardV1 intro={intro} progress={progress} theme={isTheme} setIntroView={setIntroView} isLoaded={isLoaded} isPortrait={isPortrait} counter={counter} /> : <CardV2 intro={intro} progress={progress} theme={isTheme}/>}
    </div>
  );
}
